import React from 'react';
import PropTypes from 'prop-types';
import ReactApexChart from 'react-apexcharts';

function PieChart({ data, labelKey, valueKey, isLoading, limit }) {
  const options = {
    chart: {
      type: 'pie',
    },
    labels: (data || [])
      .filter((x, i) => i < limit)
      .map((item) => item[labelKey] ?? null),
    theme: {
      monochrome: {
        enabled: true,
        color: '#977ed1',
      },
    },
    legend: {
      // show: false,
      position: 'bottom',
    },
  };
  const series = (data || [])
    .filter((x, i) => i < limit)
    .map((item) => item[valueKey] ?? null);
  if (isLoading) {
    return (
      <div className="h-full w-full flex">
        <div className="m-auto">
          <div className="h-64 w-64 rounded-full relative bg-gray-200 animate-pulse" />
          <div className="grid grid-cols-3 gap-3 mt-6">
            <div className="animate-pulse bg-gray-200 h-8 w-full rounded" />
            <div className="animate-pulse bg-gray-200 h-8 w-full rounded" />
            <div className="animate-pulse bg-gray-200 h-8 w-full rounded" />
          </div>
        </div>
      </div>
    );
  }
  return (
    <ReactApexChart
      height="100%"
      options={options}
      series={series}
      type="pie"
    />
  );
}

PieChart.defaultProps = {
  labelKey: 'title',
  valueKey: 'count',
  isLoading: false,
  data: [],
  limit: 10,
};

PieChart.propTypes = {
  limit: PropTypes.number,
  isLoading: PropTypes.bool,
  labelKey: PropTypes.string,
  valueKey: PropTypes.string,
  data: PropTypes.instanceOf(Array),
};

export default PieChart;
